import { Outlet } from "@tanstack/react-router";
import { AuthFunnelSync } from "#/components/analytics/auth-funnel-sync";
import { AuthSync } from "#/components/auth/auth-sync";
import { LoginDialog } from "#/components/auth/login-dialog";
import Footer from "#/components/Footer";
import Header from "#/components/header";
import { HyperUserEventsSync } from "#/components/hyperliquid/hyper-user-events-sync";
import { TransferStatusSync } from "#/components/wallet/transfer-status-sync";

/**
 * App chrome shared by the root `/_app` layout and the locale-prefixed
 * `/ko/_app` layout — header/footer + auth/event/transfer syncs + the
 * globally-mounted login dialog. Renders `<Outlet/>` so each layout route shows its matched
 * child.
 */
export function AppLayout() {
	return (
		<>
			<AuthSync />
			<AuthFunnelSync />
			<HyperUserEventsSync />
			<TransferStatusSync />
			<Header />
			<Outlet />
			<Footer />
			<LoginDialog />
		</>
	);
}
